export default __webpack_public_path__ + "static/cr-3ff4d657f48b190c364c024f55626993.svg";